/**
 * managedOverlayEvents — SỰ KIỆN ĐÓNG/MỞ mà `ManagedDropdown` phải NỐI LẠI cho từng loại lớp nổi.
 *
 * Vì sao tách ra: `ManagedDropdown` bóc `onOpen`/`onClose` ra khỏi props (để tự chen việc xin/trả
 * z-index), rồi CHỈ nối lại cho `select` và `autocomplete`. Hệ quả: `menu`/`popover`/`tooltip` mất luôn
 * `onClose` — menu mở ra thì bấm ra ngoài không tắt được, buộc phải chọn một mục mới thoát. Lỗi thuộc
 * loại "im lặng": không cảnh báo, không lỗi, chỉ là người dùng thấy vướng.
 *
 * File KHÔNG import gì để test node chạy được trên chính mã nguồn này.
 */

// Danh sách sự kiện MUI THẬT SỰ có ở từng component (thừa một cái là React cảnh báo prop lạ trên DOM):
//  - Select / Autocomplete / Tooltip : có cả onOpen và onClose
//  - Menu / Popover                  : CHỈ có onClose
//  - DatePicker & anh em, TablePagination: đã được nối riêng trong nhánh specificProps -> để trống
const OVERLAY_EVENT_PROPS = {
	select: ['onOpen', 'onClose'],
	autocomplete: ['onOpen', 'onClose'],
	tooltip: ['onOpen', 'onClose'],
	menu: ['onClose'],
	popover: ['onClose'],
	datepicker: [],
	datetimepicker: [],
	timepicker: [],
	tablepagination: [],
};

/** Các prop sự kiện cần nối lại cho `type`. Type lạ -> mảng rỗng (không bịa prop cho MUI). */
function overlayEventProps(type) {
	const list = OVERLAY_EVENT_PROPS[type];
	return Array.isArray(list) ? list : [];
}

export { OVERLAY_EVENT_PROPS, overlayEventProps };
